import { jsxs as e, Fragment as r, jsx as o } from "react/jsx-runtime";

import { memo as t, useState as i, useEffect as l, cloneElement as a, Children as n } from "react";

import { useFloating as s, autoUpdate as d, offset as c, flip as m, shift as p, useHover as f, useFocus as b, useDismiss as g, useRole as h, useInteractions as u } from "@floating-ui/react";

import w from "../../utils/classNames/index.js";

import y from "../../utils/isElementTabbable/index.js";

import { getArrowClassName as x } from "./util.js";

const v = (e = 6) => [ c(e), m({
    fallbackAxisSideDirection: "start"
}), p() ], N = {
    xs: "p-xs",
    s: "p-s",
    m: "p-m"
}, k = {
    dark: {
        root: "bg-neutral-700 text-white",
        arrow: "border-neutral-700"
    },
    light: {
        root: "bg-white border border-primary",
        arrow: "border-white"
    }
}, j = t((({children: t, content: c, placement: m = "right-start", contentOffset: p = "s", variant: j = "dark", showArrow: E = !1, controlled: O, isVisible: z, delayOpen: A = 300, delayClose: C = 300, delay: D = 300, hoverMove: F = !1}) => {
    const [M, P] = i(!1), R = O ? z : M, {x: T, y: V, refs: $, strategy: _, context: G} = s({
        open: R,
        placement: m,
        strategy: "fixed",
        onOpenChange: O ? void 0 : P,
        middleware: v(E ? 32 : 6),
        /* autoUpdate prevents viewport overflow with shift() & flip() middlewares */
        whileElementsMounted: d
    }), S = f(G, {
        move: F,
        delay: {
            open: D || A,
            close: D || C
        }
    }), q = b(G), B = g(G), H = h(G, {
        role: "tooltip"
    }), {getReferenceProps: I, getFloatingProps: J} = u([ S, q, B, H ]);
    if ("production" !== process.env.NODE_ENV) {
        const e = $.reference.current;
        l((() => {
            e && !y(e) && console.log("%cTooltip trigger element must be reachable by keyboard. Got wrong element: %o", "color: red; font-size: 20px", e);
        }), [ e ]);
    }
    return e(r, {
        children: [ a(n.only(t), {
            ref: $.setReference,
            ...I(),
            // Replaces aria-describedby returned from getReferenceProps. The aria-describedby was disapearing if the tooltip was not being hovered.
            "aria-describedby": `id${J().id}`
        }), e("div", {
            ref: $.setFloating,
            style: {
                position: _,
                top: V ?? 0,
                left: T ?? 0
            },
            className: w("z-[10000] w-max max-w-[min(35em,_90vw)]", R ? "block" : "hidden"),
            ...J(),
            id: `id${J().id}`,
            children: [ o("div", {
                className: w("typography-body h-full w-full overflow-auto rounded-lg", N[p], k[j]?.root),
                children: c
            }), !!E && o("span", {
                className: x(m, k[j]?.arrow),
                "aria-hidden": "true"
            }) ]
        }) ]
    });
}));

export { j as default };
//# sourceMappingURL=index.js.map
